export default "__VITE_ASSET__DTfPDxjY__"